export default "__VITE_ASSET__DIdM1m4v__"